import React from 'react';
import { Icon } from '@surveycake/rc';
import { calendarAltOutlined } from '@surveycake/rc';
import { SinglelineTextField } from 'app/pages/Survey/Subject/elements';
import { useStyles } from './styles';

export interface DisplayProps {
  date: string;
  onClick: () => void;
}

export default function Display({ date, onClick }: DisplayProps) {
  let value = '';
  const styles = useStyles();

  if (date) {
    const [year, month, day] = date.split('-');
    value = `${month} / ${day} / ${year}`;
  }

  return (
    <div className={styles.display} onClick={onClick}>
      <SinglelineTextField
        value={value}
        placeholder="MM / DD / YYYY"
        readOnly
      />
      <Icon className={styles.calendarIcon} icon={calendarAltOutlined} />
    </div>
  );
}
